(function ($) {

    var jumpLink = $(".jump-links a");

    jumpLink.click(function () {

        var jumpUrl = $(this).attr("href");

        if ($(window).width() < 980) {
            $("html, body").animate({ scrollTop: $(jumpUrl).offset().top - 75 }, 500);
        } else {
            $("html, body").animate({ scrollTop: $(jumpUrl).offset().top - 80 }, 500);
        }

        return false;
    });

})(window.jQuery);